document.addEventListener("visitorConsentCollected", (event) => {
  window.OneTrust.OnConsentChanged(e => {
    const activeGroups = e.detail || [];
  
    const preferencesAllowed = activeGroups.includes('C0001')
    const marketingAllowed = activeGroups.includes('C0003')
    const analyticsAllowed = activeGroups.includes('C0002') || activeGroups.includes('C0005')
    const saleOfDataAllowed = activeGroups.includes('C0004')
  
    window.Shopify.customerPrivacy.setTrackingConsent({
      "analytics": analyticsAllowed,
      "marketing": marketingAllowed,
      "preferences": preferencesAllowed,
      "sale_of_data": saleOfDataAllowed
    }, () => {});
  })
});